/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_Stage_OverlineInputs */

const en_mk_abt_stage_overline = /** @type {(inputs: Mk_Abt_Stage_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stage`)
};

const id_mk_abt_stage_overline = /** @type {(inputs: Mk_Abt_Stage_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tahap`)
};

/**
* | output |
* | --- |
* | "Stage" |
*
* @param {Mk_Abt_Stage_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_stage_overline = /** @type {((inputs?: Mk_Abt_Stage_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_Stage_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_stage_overline(inputs)
	return en_mk_abt_stage_overline(inputs)
});